import DiscordLogo from '../../src/legacy/DiscordLogo.tsx';
export default DiscordLogo;
